import { IPublicClientApplication } from '@azure/msal-browser';
import { loginRequest } from '../../utils/AuthConfig';
import { isAPIFailed, isAPISuccess } from '../../utils/Util';
import {
  ROLE_AMO,
  ROLE_IDS_BANCA,
  ROLE_IDS_IIB,
  ROLE_IDS_OMDC,
} from '../../utils/RBAC';
import { ThunkDispatch } from 'redux-thunk';
import {
  itusLogin,
  setAuthenticated,
  setLocalLogout,
} from '../../features/loginSlice';
import { LOGIN_STATUS } from '../../utils/Constant';
import { toast } from 'react-toastify';

export const callLogin = (
  e: any,
  setShowLoader: (value: boolean) => void,
  instance: IPublicClientApplication
) => {
  if (e) e.preventDefault();
  setShowLoader(true);
  instance.loginRedirect(loginRequest).catch(() => {});
};
export const addListener = (
  instance: IPublicClientApplication,
  setShowLoader: (value: boolean) => void,
  onSuccessfulLogin: (payload: any) => void
) => {
  instance.addEventCallback((event: any) => {
    if (
      event.eventType === 'msal:acquireTokenSuccess' ||
      event.eventType === 'msal:loginSuccess'
    ) {
      setShowLoader(true);
      if (event?.payload?.account) {
        onSuccessfulLogin(event.payload);
      } else {
        callLogin(null, setShowLoader, instance);
      }
    }
  });
};
export const getRequestData = (payload: any) => {
  const data = {
    employeeName: payload.account.name,
    email: payload.account.username,
    accessToken: payload.accessToken,
    accessExpiryTime: payload.expiresOn,
    resetToken: payload.idToken,
    resetExpiryTime: payload.extExpiresOn,
    mobile_device_token: null,
  };
  return data;
};
export const logoutWithTimer = (instance: IPublicClientApplication) => {
  setTimeout(() => {
    instance.logoutRedirect();
  }, 2000);
};
export const errorWithTimer = (message: string) => {
  setTimeout(() => {
    toast.error(message);
  }, 500);
};
export const validateLogin = (
  fulfilled: any,
  instance: IPublicClientApplication,
  dispatch: ThunkDispatch<any, any, any>
) => {
  if (isAPIFailed(fulfilled)) {
    toast.error(fulfilled.responseInformation.responseMessage);
    dispatch(setLocalLogout());
    errorWithTimer('Logout..., Please contact admin.');
    logoutWithTimer(instance);
  } else if (isAPISuccess(fulfilled)) {
    if (
      fulfilled?.result?.roleId &&
      ROLE_IDS_IIB.includes(fulfilled.result.roleId)
    ) {
      dispatch(itusLogin({ mobile: '9999999999' }));
      toast.success(fulfilled.responseInformation.responseMessage);
      dispatch(
        setAuthenticated({
          status: LOGIN_STATUS.AUTHENTICATED,
          user: fulfilled.result,
        })
      );
    } else if (
      fulfilled?.result?.roleId &&
      ROLE_IDS_OMDC.includes(fulfilled.result.roleId)
    ) {
      toast.success(fulfilled.responseInformation.responseMessage);
      dispatch(
        setAuthenticated({
          status: LOGIN_STATUS.AUTHENTICATED,
          user: fulfilled.result,
        })
      );
    } else if (
      fulfilled?.result?.roleId &&
      ROLE_AMO.includes(fulfilled.result.roleId)
    ) {
      toast.success(fulfilled.responseInformation.responseMessage);
      dispatch(
        setAuthenticated({
          status: LOGIN_STATUS.AUTHENTICATED,
          user: fulfilled.result,
        })
      );
    } else if (
      fulfilled?.result?.roleId &&
      ROLE_IDS_BANCA.includes(fulfilled.result.roleId)
    ) {
      toast.success(fulfilled.responseInformation.responseMessage);
      dispatch(
        setAuthenticated({
          status: LOGIN_STATUS.AUTHENTICATED,
          user: fulfilled.result,
        })
      );
    } else {
      dispatch(setLocalLogout());
      errorWithTimer(
        'You do have have access. Please contact admin. Logout....'
      );
      logoutWithTimer(instance);
    }
  }
};
